import { FileText } from 'lucide-react';
import Link from 'next/link';
import { ReactElement } from 'react';
import { paths } from 'src/config/paths';

import { Button, Card, CardContent, Text } from '@/design-system/components/ui';

interface AffiliateApplicationsEmptyStateProps {
  slug: string;
}

export const AffiliateApplicationsEmptyState = ({ slug }: AffiliateApplicationsEmptyStateProps): ReactElement => {
  return (
    <Card>
      <CardContent>
        <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:gap-4 tw:py-8">
          <div className="tw:flex tw:items-center tw:justify-center tw:w-16 tw:h-16 tw:rounded-full tw:bg-primary/8 tw:text-primary">
            <FileText size={32} aria-hidden="true" />
          </div>
          <Text variant="title-sm">No form configured</Text>
          <Text variant="body-md" color="muted" className="tw:max-w-[400px]">
            This project doesn&apos;t have an affiliate application form configured yet. Once a form is set up,
            affiliate applications will appear here.
          </Text>
          <Button asChild variant="primary">
            <Link href={paths.project.affiliateManagement.applicationFormBuilder(slug)}>Create Form</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
